import { useNavigate, useLocation } from "react-router-dom";
import { t, getLang } from "../../lang";
import {useEffect, useState} from "react";
const itemData = [
    {
        name : "menu.new_game",
        icon : <img style={{height: 20}} src="/img/icons/new.png" alt="gift" />,
        link : '/newgame'
    },
    {
        name : "menu.favorite_game",
        icon : <img style={{height: 20}} src="/img/icons/rec.png" alt="favorite" />,
        link : '/favorite'
    },
    {
        name : "menu.slot",
        icon : <img style={{height: 20}} src="/img/icons/all.png" alt="gift" />,
        link : '/slot'
    },
    // {
    //     name : "menu.live",
    //     icon : <img src="/img/icons/live.svg" alt="live" />,
    //     link : '/live'
    // },
] ;

export default function LandingNavBar(){
    const navigate = useNavigate() ;
    const location = useLocation() ;
    const [lang, setLangState] = useState(getLang());

    useEffect(() => {
        const handler = () => setLangState(getLang());
        window.addEventListener("langChanged", handler);
        return () => window.removeEventListener("langChanged", handler);
    }, []);

    const navigatePage = ( link ) => e => {
        navigate( link, { replace : true } ) ;
    }
    return(
        <>
            <div style={{ backgroundColor: "#000" , padding: "10px 0" }}>
            <div className='landing-nav-mobile'>
                {
                    itemData.map( ( item, index ) => (
                        <div 
                            className={`landing-nav-mobile-item ${location.pathname === item.link ? 'active' : ''}`} 
                            key={ index } 
                            onClick={ navigatePage( item.link ) }
                        >
                            { item.icon }
                            <span>{ t(item.name) }</span>
                        </div>
                    ) )
                }
            </div>
            </div>
        </>
    )
}